import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CHANNEL_EVIDENCES_TYPES,
} from '../../../actions/actionTypes';

const channelEvidenceTypes = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CHANNEL_EVIDENCES_TYPES
);

export default channelEvidenceTypes;
